import { SubscriptionBirthFamilyFormVM } from 'subscription/view-models/subscription-registration-birth-family';
import { Citizenship } from 'shell/models/person/citizenship';
import { FamilyCoexistence } from 'shell/models/person/family';
import { SubjectAttributes } from 'shell/models/person/subject-attributes';
import { Generality } from 'shell/models/person/generality';
import { CompleteSubjectLink } from 'shell/models/person/complete-subject-link';
import {
  ControlData,
  RequestSubscriptionBirth,
} from 'subscription/models/request-subscription-birth';
import {
  transformAllegati,
  transformDatiControllo,
  transformFamiglia,
  transformGeneralita1001,
  transformLegameSoggetto,
  transformMaternita,
  transformerPaternita,
} from './common-request-transformer';
import { IDRequested } from 'subscription/components/shared/edit-data/requested-list';
import { transformerAttoNascitaFamily } from './birthday-document.transformer';

export const transformerRequestSubscriptionBirthFamilyData = (
  values: SubscriptionBirthFamilyFormVM,
  isCohabitation?: boolean
): RequestSubscriptionBirth => {
  const attoNascita = transformerAttoNascitaFamily(values.birthdayDocument);

  const hasCitizenship =
    !!values.citizenship?.state || !!values.citizenship?.note || !!values.citizenship?.validity;

  const cittadinanza: Citizenship | undefined = hasCitizenship
    ? {
        codiceStato: values.citizenship?.state?.id || undefined,
        dataValidita: values.citizenship?.validity
          ? values.citizenship?.validity?.toFormat('yyyy-MM-dd')
          : undefined,
        descrizioneStato: values.citizenship?.state?.value || undefined,
        noteStato: values.citizenship?.note || undefined,
      }
    : undefined;

  const famConv: FamilyCoexistence | undefined = values.familyCoexistence
    ? transformFamiglia(values?.familyCoexistence, values?.type, isCohabitation)
    : undefined;

  const generalita1001: { attributiSoggetto?: SubjectAttributes; generalita: Generality } =
    transformGeneralita1001(values.generality, values.civilStatus);

  const legameSoggetto: CompleteSubjectLink = transformLegameSoggetto(
    values.familyCoexistence,
    isCohabitation
  );

  const datiControllo: ControlData = transformDatiControllo(values?.editDataControl);

  const paternita = !(
    values.editDataControl?.requested === IDRequested.Genitori ||
    values.editDataControl?.requested === IDRequested.Padre
  )
    ? undefined
    : transformerPaternita(values.fatherhood);

  const maternita = !(
    values.editDataControl?.requested === IDRequested.Genitori ||
    values.editDataControl?.requested === IDRequested.Madre
  )
    ? undefined
    : transformMaternita(values.motherhood);

  const allegati = transformAllegati(values.document);

  return {
    attoNascitaANPR: attoNascita || undefined,
    cittadinanza,
    codiceComune: values?.generality?.foreign?.municipality?.id
      ? Number.parseInt(values?.generality?.foreign?.municipality?.id)
      : undefined,
    famConv,
    generalita1001,
    legameSoggetto,
    // manca dati procedimento
    datiControllo,
    paternita,
    maternita,
    allegati,
    natoMorto: values?.generality?.deathPerson || undefined,
  };
};
